const module = 'chatbot'
import { checkAuth } from '@/services/auth'
import Index from '@/views/chatbot/Index'
import Show from '@/views/chatbot/Show'
import Settings from '@/views/chatbot/Settings'

var prefix = '/'

export default [
  {
    path: prefix + module + '/',
    name: module + 'Index',
    component: Index,
    beforeEnter(to, from, next) {
      checkAuth().then(ok => ok ? next() : next('/login'));
    }
  },
  {
    path: prefix + module + '/settings',
    name: module + 'Settings',
    component: Settings,
    beforeEnter(to, from, next) {
      checkAuth().then(ok => ok ? next() : next('/login'));
    }
  },
  {
    path: prefix + module + '/:id',
    name: module + 'Show',
    component: Show,
    beforeEnter(to, from, next) {
      checkAuth().then(ok => ok ? next() : next('/login'));
    }
  }
]
